customElements.define(

  "cc-section", 

  class extends HTMLElement{

        connectedCallback(){

            let height = this.getAttribute("height");
            const element = this.innerHTML;

            if( height == "" || !height ){
                height = "auto";
            }

            this.innerHTML = `
            <section id="cc-custom-section">

                <div id="content-wrapper">

                    <div id="content" style="min-height:${height};">
                        ${element}
                    </div>

                </div>

            </section>      

            `;



        }
       
    }

);